export default [
    {
        title: "v2.0.6 | Nexus Dynamics Hotfix",
        thumbnail: "/imgs/blogPost/nexusstatst5.jpg",
        description: "New themes, changes, and hotfixes for Nexus Dynamics.",

        author: {
            image: "/imgs/donpfp.png",
            name: "Donavan",
            published: "May 9 2025",
            type: "Hotfix"
        },

        content: [
            "<div align='center'>Welcome back developers, we've got an update for you.</div>",
            "",
            "# New",
            "* We've introduced five brand new themes for you to enjoy:",
            "   * Coffee\n", 
            "       ![57%](/imgs/blogPost/themePreview.jpg)",
            "   * Modern\n", 
            "       ![57%](/imgs/blogPost/themePreview(1).jpg)",
            "   * Retro\n", 
            "       ![57%](/imgs/blogPost/themePreview(2).jpg)",
            "   * Scifi\n", 
            "       ![57%](/imgs/blogPost/themePreview(3).jpg)",
            "",
            "Special thanks to `@THEDRAGONSMINIL` for providing the themes during the UGC Theme event.",
            "# ",
            "# Changes",
            "* We've updated the light theme with a few new color variations.",
            "* Tags has been shifted around for easier version control.",
            "* Changed **UserRegisteryService** SetAsync -> SaveAsync",
            "# ",
            "# Fixes",
            "* The UI will now scale correctly when launching Roblox window below 1100 pixels width.",
            "* BanServices history has been fixed to give the correct player history.",
            "* Checkban will now correctly check if a player is banned.",
            "* Unban will now correctly unban a player.",
            "# ",
            "",
            "Documentation for Nexus Dynamics v2.0.5 is currently being written and will be announced soon.",
            "",
            "As always, we're excited to hear from you, let us know through *info@devequip.com* or [Discord](https://www.devequip.com/discord/)",
            "",
            "Thank you for all the support 💙",
            "",
            "*The Dev Equip Team*",
        ].join("\n")
    },

    {
        title: "v2.0.5 | Nexus Dynamics Hotfix",
        thumbnail: "/imgs/blogPost/nexusstatst5.jpg",
        description: "Hotfix for all bugs for v2.0.5's release.",

        author: {
            image: "/imgs/donpfp.png",
            name: "Donavan",
            published: "April 23 2025",
            type: "Hotfix"
        },

        content: [
            "<div align='center'>Welcome back developers, we've got an update for you.</div>",
            "",
            "As we released Nexus Dynamics v2.0.5 last Saturday, we've been hit by a wave of bug reports. This update is mostly for those that have been reported or acknowledged by **The Dev Equip Team**. If you have any knowledge of a bug not mentioned, please let us know through one of our socials.",
            "",
            "# ",
            "# New",
            "* Introduced a few new libraries:",
            "   * **Cache** — Responsible for creating a cached metatable.",
            "   * **Changed** — Responsible for applying the changed effect to metatables.",
            "* Introducing a new services to handle UserRegisteries with ease.",
            "* Added a new `/debug` command to return the log history as json.",
            "# Changed",
            "* Completely rewritten all server-side scripts to run as efficiently as possible.",
            "* Setup and RankService now share the same datastore key.",
            "* Services has been changed to exclude running threads/connections.",
            "* Added various modules/code snippets to run said threads/connections.",
            "* Format AI flags/rules has been shifted around in independent modules",
            "* ServerLock will now lock the server accurately.",
            "* Added protection against banning the owner directly.",
            "* Replaced the **Maid** module with a proper **Maid handler**.",
            "* The `User` qualifier will now always return userIds.",
            "* Ranking with `/setup` will now always save type user ranks by UserIds.",
            "* Added a new templates folder for easy replication of default data.",,
            "# API Changes",
            "* All type checking is now handled by the `Types` module.",
            "* All ranking procedures will log MessageInfo to the log library.",
            "# Removed",
            "* ServerBan has been temporarily removed to increase efficiency",
            "# Fixed",
            "* Fixed incorrect **FontFace** syntax for Fusion code when generating `;title`.",
            "* Fixed a spelling mistake that caused warp to error with wrap.",
            "* The hint popup will now correctly disappear after 20 seconds.",
            "* The `;team` command will now accurately obtain the selected team.",
            "* Unranking an administrator will now remove the Topbar/Panel entirely.",
            "* Fixed caching troubles for all server-sided caching.",
            "* CheckBan will now detect the **User** qualifier.",
            "* Unban will now send a userId instead of an array of userIds.",
            "* Shutdown command will now cause the server to shutdown properly.",
            "* Topbar will no longer hide randomly.",
            "# Known Issues",
            "* Auto-Update or GetLatestPackageVersion might fail. **ReInsert the model if this happens**",
            "* The menu wheel isn't smooth between transitioning between options.",
            "* Old commands relating to R15/R6 conversions will not work unless you have the correct rig before hand.",
            "* Commands won't produce a log entry for Audit Log.",
            "* A few colors/settings won't change without rejoining.",
            "* Command Prompt may rarely suggest a command instead of required argument.",
            "* Attempting to open the panel too quickly will result in an error.",
            "___",
            "Documentation for Nexus Dynamics v2.0.5 is currently being written and will be announced soon.",
            "",
            "As always, we're excited to hear from you, let us know through *info@devequip.com* or [Discord](https://www.devequip.com/discord/)",
            "",
            "Thank you for all the support 💙",
            "",
            "*The Dev Equip Team*",
        ].join("\n")
    },

    {
        title: "Nexus Dynamics Rework v2.0.5",
        thumbnail: "/imgs/blogPost/nexusstatst5.jpg",
        description: "Changelog for the brand new version of Nexus Dynamics consisting of a new API, overhauled framework, and much more...",

        author: {
            image: "/imgs/donpfp.png",
            name: "Donavan",
            published: "April 19 2025",
            type: "Changelog"
        },

        content: [
            "<div align='center'>Welcome back developers, we've got an update for you.</div>",
            "",
            "This time around, the update to Nexus Dynamics brings along a rewritten source and drastic performance improvements, including boost in load times, interactions between the server/client, and much more... ",
            "",
            "We hope you're just as excited as we to release this update, so lets hop right into whats new.",
            "# ",
            "# Installation",
            "* The setup for Nexus Dynamics has changed and can be found here: [Nexus Dynamics / Installation](/docs/nexusdynamics/installation/)",
            "* Upon failure of correct setup, Nexus Dynamics will forcefully prompt `/setup` which can be used to identify the problem.",
            "* Nexus Dynamics now utilizes packages for easier updates.",
            "* Custom Commands & Tools has been moved into a new **Custom** folder.",


            "# Ranking",
            "A new optional ranking window has been added into `/setup` making it easier and less complicated for non-programmers.",
            "<table>",
            "<thread>",
            "<tr>",
            "<th>Type</th>",
            "<th>Input</th>",
            "<th>Extra</th>",
            "<th>Rank</th>",
            "</tr>",
            "</thread>",
            "<tbody>",
            "<tr>",
            "<td>User</td>",
            "<td>Username</td>",
            "<td></td>",
            "<td>VIP-Admin</td>",
            "</tr>",
            "<tr>",
            "<td>Group</td>",
            "<td>GroupId</td>",
            "<td>0-255</td>",
            "<td>VIP-Admin</td>",
            "</tr>",
            "<tr>",
            "<td>Asset</td>",
            "<td>AssetId</td>",
            "<td></td>",
            "<td>VIP-Admin</td>",
            "</tr>",
            "<tr>",
            "<td>Gamepass</td>",
            "<td>PassId</td>",
            "<td></td>",
            "<td>VIP-Admin</td>",
            "</tr>",
            "<tr>",
            "<td>Free</td>",
            "<td>(Conditional)</td>",
            "<td></td>",
            "<td>VIP-Admin</td>",
            "</tr>",
            "<tr>",
            "<td>Friends</td>",
            "<td>(Conditional)</td>",
            "<td></td>",
            "<td>VIP-Admin</td>",
            "</tr>",
            "<tr>",
            "<td>PrivateServerOwner</td>",
            "<td>(Conditional)</td>",
            "<td></td>",
            "<td>VIP-Admin</td>",
            "</tr>",
            "</tbody>",
            "</table>",
            "",
            "# New",
            "* The model is now officially a package with the following capabilities:",
            "   * Auto-Update to sync the source-code with the latest version.",
            "   * Version control between old and new updates.",
            "   * Easier method of updating after a hotfix.",
            "* Nexus Dynamics will now add a `/setup` command to TextChatService for **Installation**",
            "* **Setup Guide:** Upon usage of `/setup` or failure of correct setup, Nexus Dynamics will do dianostics and assist setting up with a visual interface.",
            "* Nexus Dynamic's topbar officially has [TopbarPlus Integration](http://www.devequip.com/newsroom/post2/)",
            "* All color values will now display the selected color in the format chosen at settings.",
            "* BanService officially uses Roblox Ban API",
            "* Brand new settings categories and options has been added:",
            "   * Toggle preview icons of various items in command prompt.",
            "   * Choose preset themes for quick makeovers.",
            "       * Dark <sup>(Default)<sup/>",
            "       * Light",
            "       * Haze",
            "       * Midnight",
            "       * Custom",
            "   * Export the current theme as a json string.",
            "   * Import external json themes as your custom theme.",
            "   * Various color values added to alter theme.",
            "   * Toggle if notifications should appear.",
            "   * Change the notification position between bottom/top + right/left.",
            "   * Toggle fly prompt from appearing.",
            "   * Toggle alerts such as warnings/errors from appearing.",
            "   * Toggle the visibility of **Debug Bar** as well as content displayed:",
            "       * Version",
            "       * Region",
            "       * FPS",
            "       * Errors",
            "       * Warnings",
            "       * Memory Usage",
            "       * Average Ping",
            "   * Toggle the visibility of **Topbar** as well as content:",
            "       * Transparency",
            "       * Position ***Left/Center/Right***",
            "* Added a new manager **Air Density** property to workspace.",
            "* Added icons to materials, teams, players, and more within **Command Prompt** suggestions.",
            "* The **PrivateServerID** can now be found in dashboard statistics.",
            "* **Audit Log**: A brand new page welcomed among the rest, capable of providing detailed log descriptions of actions done through administrative permissions.",
            "   * Manager Skybox/Value Changes",
            "   * Commands through chat/command prompt",
            "   * Server Migration",
            "   * Fatal Errors",
            "   * Editor Edits (Coming Soon)",
            "# Changes",
            "* Administrative tools are now only obtainable using the command. `;tool <player> <name>`",
            "* Slightly redesigned the CoreGui section under manager.",
            "* **Interface Design:** has received a slight make over for less UI elements but producing the same appearance.",
            "   * Utilizes the **Fusion** framework to generate UI when needed.",
            "   * Slider property values have been replaced with physical sliders.",
            "   * Dropdown boxes now display 4 options.",
            "   * All Number/String input property values has been replaced with physical TextBox.",
            "   * The manager skybox subsection in lighting now only displays Skyboxes.",
            "   * Ambient Reverb property will now correctly alter SoundService.",
            "* Gravity Coil tool will now be generated when using the command.",
            "* Speed Coil tool will now be generated when using the command.",
            "* Sword Coil tool will now be generated when using the command.",
            "* Jail cells are now generated when a cell is required.",
            "* The **BillboardGui** for `;title` is now generated when required.",

            "# API Changes",
            "* Nexus Dynamics now has advanced type-checking involved for outside usage.",
            "* Various commands can no longer be used against the owner of the experience/group",
            "* Roblox Ban API is now utilized by BanService.",
            "   * `;checkban`, `;serverban`, `;timeban`, `;ban`, `;unban` now works with ***Player:BanAsync()***",
            "   * Developers can view banland/list through the Creator Dashboard.",
            "   * Nexus Dynamics now bans players through their IPs. (Alt protection)",
            "* Nexus Dynamics has shifted to caching with global variables.",
            "* Requiring the Connector module will result in obtaining the cached libraries of Nexus Dynamics since the initial launched version.",
            "* Naming conventions now work under `name@source-version`. ***Currently: @2.0.5***",
            "   * This is applied for both global variables and object names.",
            "* RankService now generates a table instead of physical Stylesheet instances.",
            "* RankService rankData now returns values of *{ Name: `string`, Id: `number` }*",

            "# Removed",
            "* Removed the morph command along with morph rigs.",
            "* Removed the lockdown command",
            "* Settings module has been removed",
            "* Configuration folder has been removed",
            "* Removed the announcement UI.",
            "* Removed a bunch of unused UI elements.",
            "* Removed Shell from both the source, commands, failsafe, and account tab.",
            "* Removed serialization.",
            "* The following panel popups has been removed:",
            "   * Input Box (string/number)",
            "   * Slider",
            "   * Player Config",
            "* Removed a few settings regarding the initial animation:",
            "   * Enabled",
            "   * Easing Speed",
            "   * Easing Style",
            "   * Animation",
            "   * Easing Direction",
            "* Notifications section under **Account Tab** has been removed",
            "* Removed Skybox celestial properties in **Manager**",
            "*  Removed various services in **Manager**:",
            "   * RankService",
            "   * Tools",
            "   * Players",
            "* Subsections in **Dashboard** has been removed:",
            "   * Statistics",
            "   * Server Management",
            "* All **SFX** has been removed apart from sounds in:",
            "   * Gravity Coil Tool",
            "   * Speed Coil Tool",
            "   * Sword Tool",
            "* The **Visual Debugger** has been removed and replaced with **Audit Log**",
            "* All editors has been temporarily removed in preperation for the new editor's framework coming soon.",
            "   * Removed Terrain Editor",
            "   * Removed Sun Editor",

            "# Fixes",
            "* The panel will now shrink to appropriate size for mobile users.",
            "* Reduced usage of CanvasGroup wrappers.",
            "* Dragging the panel will no longer cause lag spikes.",
            "* Eliminated pixelation between CanvasGroup depths.",
            "* Saving the map will now disable all scripts when cached.",
            "* RankService will now always rank a player when entering the experience.",
            "* RankService will no longer take 80% of the memory.",
            "* Undo versions of all commands will no longer display moderator+.",
            "* You can no longer obtain multiple panels at once.",
            "* Format AI will now accurately distinquise qualifier types.",
            "* Global variables will now collect cache, resulting in less overwriting.",
            "* RemoteEvent/RemoteFunctions now go through security checks correctly regarding ranks.",
            "* The search bar in commandlist will now use `string.find` instead of comparing `string.sub`.",
            "* The clock will now display the correct timezone.",
            "* Debug will more accurately calculate ping.",
            "* Undo commands will now be displayed in both commandlist and command prompt suggestions.",
            "* Dropdown boxes will no longer re-select itself when activating the dropdown itself.",
            "* BuildInfo will now correctly display all versions and Ids.",
            "* Notifications will now display for non administrators.",
            "* Command Prompt will no longer scale uncontrolably after suggestions.",
            "* Topbar will no longer hide behind TopbarPlus.",
            "* Notification's ScreenGui now uses CoreGuiInset.",
            "* Reduced Gui depth count by 33.33% decreasing rendering times.",
            "* Boot up times has been decreased overall by 96%.",

            "# Known Issues",
            "* The menu wheel isn't smooth between transitioning between options.",
            "* Commands won't produce a log entry for Audit Log.",
            "* A few colors/settings won't change without rejoining.",
            "* Command Prompt may rarely suggest a command instead of required argument.",
            "* Attempting to open the panel too quickly will result in an error.",
            "___",
            "Documentation for Nexus Dynamics v2.0.5 is currently being written and will be announced soon.",
            "",
            "As always, we're excited to hear from you, let us know through *info@devequip.com* or [Discord](https://www.devequip.com/discord/)",
            "",
            "Thank you for all the support 💙",
            "",
            "*The Dev Equip Team*",
        ].join("\n")
    },

    {
        title: "Nexus Dynamics Overhaul - Release Date Announcement",
        thumbnail: "/imgs/blogPost/nexusstatst5.jpg",
        description: "The developer reveals the release date for Nexus Dynamics v2.0.5 in addition to previews and information!",

        author: {
            image: "/imgs/donpfp.png",
            name: "Donavan",
            published: "March 11 2025",
            type: "Dev Preview"
        },

        content: [
            "Today, we’re excited to announce a brand new version coming to our lead project Nexus Dynamics. The update will be available across multiple platforms on **April 19th, 2025**. Exact release timing will be disclosed near the release over on our [Community Discord](https://devequip.com/discord) server.",
            "",
            "If you’re new to Dev Equip, Nexus Dynamics is our biggest project yet, crafted with simplistic user-experience whilst innovating unique features for management. [Check it out](https://devequip.com/product/nexusdynamics)",
            "",
            "The patch notes for v2.0.5 will be revealed as a separate blog when the update launches.",
            "# ",
            "Furthermore, we’ve decided to give you a little sneak peek at what we’ve been working on for the past 4 months. Nexus Dynamics has been transitioning towards a UI Framework with the help of Fusion. This framework allows us to write all UI efficiently and render on command lowering the file size and load times.",
            "",
            "Take a look below for some before/after comparisons of performance between **v2.0.2** and **v2.0.5**",
            "",
            "![](/imgs/blogPost/nexusstatst1.jpg)",
            "",
            "Loading times has been improved by a whopping 96.26%. Making the panel load almost immediately for fast and reliable management whilst keeping memory clean from unnecessary spikes.",
            "",
            "Due to the framework challenging us with manually writing the gui objects, we’ve redesigned the entire panel to be at the lowest amount of elements possible. Cleaning up any pages filled with unused or unnecessary blocks and lowering the depth count.",
            "# ",
            "![](/imgs/blogPost/nexusstatst3.jpg)",
            "",
            "You will no longer have any lag within Roblox Studio when inserting or moving the file around. Especially when test-playing in Roblox Studio, you'll instantly get in without waiting 10-30 seconds to load.",
            "# ",
            "![](/imgs/blogPost/nexusstatst2.jpg)",
            "",
            "We’ve optimized the panel beyond our previous knowledge, and have come to a reasonable stage of unaffected FPS during casual use of Nexus Dynamics for ordinary management. We’re still working on optimizing any excessive feature such as the editors.",
            "# ",
            "___",
            "# ",
            "Mobile is an essential part of Roblox and shouldn’t be an exception to our magnificent panel. Therefore, we’ve decided to use this time to add mobile support in the best way we can. Unfortunately, mobile players will only be able to view the commands tab in a separate window.",
            "",
            "Nexus Dynamics was built with complex mechanics meant for keybinds and the usage of a mouse.  Mobile unfortunately isn’t compatible with the vision of Nexus Dynamics. This is why we’re implementing easy moderation features such as a quick-ban window in the near future.",
            "# ",
            "___",
            "# ",
            "We’re temporarily removing all editors and bringing them back in v2.1 with the brand new editor framework. This framework will make it so mobile users can use our editors whilst also creating a much more stable system with reliable history trackers and possibly saving changes to Roblox Studio.",
            "",
            "As a reward for everyone’s patience whilst we go carefully develop these new editors, we want to reward the community with brand new editors!",
            "",
            "By introducing Studio Editor, Light Editor, Player Editor, and Paint Editor. This will give Nexus at least 6 different editors to play with.",
            "",
            "More information about these editors will be revealed after the launch of v2.0.5 and v2.1 development phase began.",
            "# ",
            "___",
            "# ",
            "We’re converting the source into a script-only environment so we can be eligible for packages! This will help us create a source that has version control with the optional auto-update feature!",
            "",
            "The default model for Nexus Dynamics will now include a source-file which will be the main package. If you don't know how to update the package to a new version, we'll explain it in the future.",
            "",
            "The settings module will be removed and replaced with a brand new in-game window that'll act similar to an installation window. This will take you through a step-by-step guide to properly setup Nexus Dynamics, rank admins, and personalize the panel.",
            "",
            "![](/imgs/blogPost/nexusstatst4.jpg)",
            "",
            "# ",
            "These were just a few new changes to the upcoming release on **April 19th, 2025**. We have lots  more to reveal in the near future, so keep an eye out for new blogs or social feeds.",
            "",
            "We’re excited to hear your thoughts, and see what you’ll do next with Nexus Dynamics.",
            "",
            "Thank you for all the support 💙",
            "",
            "*The Dev Equip Team*",
        ].join("\n")
    },

    {
        title: "Introducing Marketplace",
        thumbnail: "/imgs/blogPost/marketplacepreview.png",
        description: "Learn more about how and why we're introducing the new marketplace for Dev Equip's products. Learn more about how and why we're introducing the new marketplace for Dev Equip's products.",

        author: {
            image: "/imgs/donpfp.png",
            name: "Donavan",
            published: "Jan 23 2025",
            type: "Dev Preview"
        },

        content: [
            "# Official Marketplace",
            "As we expand the website, we're slowly turning it into the official hub for Dev Equip products. Our products will now be primarily obtained within the marketplace, and fitted with source/file formats. All files will remain as Roblox creator store assets with RBXM/RBXL until file formating arrives. We'll talk more about file formats later on.",

            "Additionally we're introducing our own review system for people willing to leave a review. These will only be available after accounts arrive and will have a chance to have your review hand-picked to be displayed on the landing page. ",

            "___",

            "# Discord Products Category",
            "We've already removed all products discontinued due to newer version such as:",
            "* Chat Plus +",
            "* Nexus Dynamics [Phase 1]",
            "* Donation Board [v1/v2]",

            "\nWhilst also removing products that need a rework for user-friendly reasons:",
            "* Proximity Prompt [v2]",
            "* Mini-Map",

            "Furthermore, we've removed all products that sit at the bottom of our statistics bin:",
            "* Various 3D Models",
            "* Various User Interfaces",
            "* All Luau Modules",

            "___",

            "# File Formats",
            "We're introducing more file formats per category when downloading for a more flexable workflow. For products that use scripts, we'll provide a source from github. All Roblox products listed below will be given unique formats:",
            "",
            "**Admin Panel**: Creator Store / RBXM",
            "",
            "**Donation Board**: Creator Store / RBXM",
            "",
            "**User Interface**: Creator Store / RBXM",
            "",
            "**Script**: Creator Store / RBXM / Lua",
            "",
            "**3D Model**: Creator Store / RBXM / FBX / Blend / OBJ",
            "",
            "**Map**: RBXL",
            "",
            "**Plugin**: Creator Store / RBXM",

            "___",

            "# Community Marketplace",
            "Although we're not anywhere near the start of development for the community marketplace, we're very enthusiastic about this idea for a community that shares resources between each other regardless of price.",
            "",
            "We'll share more information about this community marketplace once we start development."

        ].join("\n")
    },

    {
        title: "v3.25 | Donation Board Hotfix",
        thumbnail: "/imgs/blogPost/dbbackground.jpg",
        description: "Quick patch for invalid developer products along with some bug fixes regarding themes and rigs.",

        author: {
            image: "/imgs/donpfp.png",
            name: "Donavan",
            published: "Jan 4 2025",
            type: "Hotfix"
        },

        content: [
            "# Changes",
            "As we expand the website, we're slowly turning it into the official hub for Dev Equip products. Our products will now be primarily obtained within the marketplace, and fitted with source/file formats. All files will remain as Roblox creator store assets with RBXM/RBXL until file formating arrives. We'll talk more about file formats later on.",
            "* Developer products with an invalid ID will no longer be displayed.",

            "___",

            "# Fixes",
            "* Correctly configured the following themes:",
            "   * Dev Equip Theme",
            "   * Hacker Theme",
            "   * Custom Theme",
            "* Rigs will no longer disappear after theme failures.",
        ].join("\n")
    },

    {
        title: "Nexus Dynamics's Integration of TopbarPlus",
        thumbnail: "/imgs/blogPost/topbarsettings.png",
        description: "Developer of Nexus Dynamics releasing public information regarding Nexus Dynamics's integration of TopbarPlus.",

        author: {
            image: "/imgs/donpfp.png",
            name: "Donavan",
            published: "Dec 18 2024",
            type: "News"
        },

        content: [
            "# What is TopbarPlus?",
            "[TopbarPlus by @ForeverHD](https://devforum.roblox.com/t/v3-topbarplus-v300-construct-intuitive-topbar-icons-customise-them-with-themes-dropdowns-captions-labels-and-much-more) is a popular framework used to recreate the default Roblox in-game menus, which are always on the top of your screen and always in sight.",
            "",
            "TopbarPlus allows you to create your own custom buttons to align with Roblox menus so you can have a much cleaner and modern looking game. TopbarPlus automatically moves buttons around to align them unless they aren't made using TopbarPlus.",
            "",
            "![Topbar Thumbnail](/imgs/blogPost/topbar.png)",
            "___",
            "# Integration of TopbarPlus to Nexus Dynamics",
            "We've made it so Nexus Dynamics will now detect whether your using TopbarPlus in your game. If you are, it'll instead create its topbar icon using TopbarPlus to align itself without overlappin any buttons.",
            "",
            "In settings, you'll get new options that'll give you selections of topbar alignment (left | center | right) alopng with some customization of the button itself.",
            "",
            "___",
            "# What if I don't use TopbarPlus?",
            "If you don't use TopbarPlus, Nexus Dynamics will create its own version of TopbarPlus UI for only the parts it needs. You'll still be able to align them to the corners or center and with Roblox Menus."
        ].join("\n")
    },

    {
        title: "Utilizing Ban API in Nexus Dynamics",
        thumbnail: "/imgs/blogPost/bancode.png",
        description: "Learn more about Roblox's Ban API and how Nexus Dynamics will to take full advantage of it.",

        author: {
            image: "/imgs/donpfp.png",
            name: "Donavan",
            published: "Dec 10 2024",
            type: "News"
        },

        content: [
            "# What is Roblox's Ban API",
            "Roblox has released a new Ban API with manyu capabilities ordinary scripts developed by Roblox developers can't manage with the given run context/permissions. These include the detection of alternative accounts (alts) and giving us the ability to use these API outside Roblox without requiring a running server. This feature was released shortly after Nexus Dynamics's final development phase; Therefore, we didn't have time to implement this system.",
            "___",
            "# Implementing Ban API into Roblox",
            "This has been our most requested feature for Nexus Dynamics and has gone through decision making to implement. We're still a little skeptical at the time of this post but we've been keeping an eyue on recent reports that fully utilize this new system without any problems. Therefore, we've decided to implement this into Nexus Dynamics v2.0.5.",
            "",
            "The new system will now give al ldevelopers the capability of managing Nexus Dynamics bans outside of the game and still be able to configure them in-game! In addition to this, we won't be wasting valuable memory on DataStoreService, assisting people that use global leaderboards with Nexus Dynamics in their experience.",
            "___",
            "# When should this be expected?",
            "The Ban API has already been developed and tested, marking it complete and ready for release. However, we're releasing it with version 2.0.5 due to the new framework we're implementing to increase performance.",
            "The exact release date for version 2.0.5 has not yet been decided; however, we've planned an approximate release date within Q2 of 2025.",
        ].join("\n")
    },
]